<div class="flex flex-col justify-start items-stretch w-full py-4" (click)="showJobDetails.emit(job())">
  <div class="flex flex-row justify-between items-center gap-x-2">
    <h2>{{ job().location }}</h2>
    <app-google-maps-link [placeId]="job().google_place_id" [address]="job().location"></app-google-maps-link>
  </div>
  <app-key-value-pair name="Customer" [value]="job().customer" />
  <app-key-value-pair name="Type" [value]="job().type | titlecase" />
  <app-key-value-pair name="Items" [value]="job().items | deliveryItemsList" />
  <div class="flex flelx-col md:flex-row justify-between md:items-center items-start w-full">
    <app-key-value-pair name="Due" [value]="job().due | amDateFormat: dateFormat" />
    @if (overdue()) {
    <p class="font-bold text-red-500">Overdue</p>
    }
  </div>
</div>